module.exports = __webpack_public_path__ + "img/maj6.c5472cea.jpg";